/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2020 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the property of
 * Pearson Education, Inc. The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S.
 * and Foreign Patents, patent applications, and are protected by trade secret
 * or copyright law. Dissemination of this information, reproduction of this
 * material, and copying or distribution of this software is strictly forbidden
 * unless prior written permission is obtained from Pearson Education, Inc.
 */

import { axiosFetch } from './axiosFetch';
import API_CONSTANTS from '../constants/apiConstants';
import { getHeaders } from '../utils';

const normalizePufv2ItemBank = item => ({
  ItemBankId: item.itemBankId || item.ItemBankId,
  ItemBankName: item.itemBankName || item.ItemBankName,
  status: item.status
});

export const getPufv2ItemBanksList = async lob => {
  const apiPath = API_CONSTANTS.GET_PUFV2_ITEM_BANKS;
  const reqOptions = {
    ...getHeaders()
  };

  const response = lob
    ? await axiosFetch(reqOptions, apiPath, { lob })
    : await axiosFetch(reqOptions, apiPath);
  const itemBanks = response.data;

  return itemBanks
    .map(normalizePufv2ItemBank)
    .filter(item => item.ItemBankId && item.ItemBankName);
};
